import Partners from "../partners";
import Legal from "./legal";
import Links from "./links/links";
import React from "react";

export default () => (
  <>
    <Links />
    <Legal />
    <Partners/>
  </>
);
